export enum ShopErrors {
  NOT_AVAILABLE = '.qty',
}
